import React from "react"
import LocalizedLink from "./localizedLink"
import { Link } from "gatsby"
import styles from "./navPopup.module.css"
import { NavContext } from "./NavContext"
import { CSSTransition } from 'react-transition-group';
import { FaWindows, FaApple, FaLinux } from 'react-icons/fa';
import { IoMdClose } from 'react-icons/io';
import useTranslations from "../utils/useTranslations"
import { unlocalizedPageCheck } from "../utils/unlocalizedPageCheck"


class NavPopup extends React.Component {

	handleLanguageClick = (e, value) => {
		this.props.togglePopup(null)
		let isUnlocalizedPage = unlocalizedPageCheck(this.props.unlocalizedPath)
		if(isUnlocalizedPage){
			e.preventDefault()
			sessionStorage.setItem('locale', value)
		    this.props.compatibilityContext(e, 'blockedLanguage', null, [])

		}
	}

  render(){

  	const t = useTranslations(this.props.navText)

	const q = {
		Products:
			<>
				<div className="d-block px-5 py-3 mx-3" >
					<div className={`mt-4 mb-2 ${styles.selection}`}>
			  			<p className={`mb-0`}>
			  				<span className="font-weight-bold bt-font text-primary">µTorrent </span> 
			  				{t("Web")}
			  			</p>
			  			<div className={`d-flex flex-column ${styles.selectionSystems} ml-4`} >
							<LocalizedLink id="mainnav-products-btweb-windows pointer" to="/web/" onClick={() => {this.props.togglePopup(null)}}> 
								<div className={`d-inline-block my-2 ${styles.img}`} >
									<FaWindows />
									Windows
								</div>
							</LocalizedLink>
							<LocalizedLink id="mainnav-products-btweb-mac" to="/web/mac/" onClick={() => {this.props.togglePopup(null)}}> 
								<div className={`d-inline-block my-2 ${styles.img} pointer`}>
									<FaApple />
									Mac
								</div>
							</LocalizedLink>
						</div>
					</div>
					<div className={`mt-2 mb-2 ${styles.selection}`}>
			  			<p className="mb-0">
			  				<span className="font-weight-bold bt-font text-primary">µTorrent </span> 
			  				{t("Classic")}
			  			</p>
			  			<div className={`d-flex flex-column ${styles.selectionSystems} ml-4`} >
							<LocalizedLink id="mainnav-products-btclassic-windows" to="/desktop/" onClick={() => {this.props.togglePopup(null)}}> 
								<div className={`d-inline-block my-2 ${styles.img} pointer`} >
									<FaWindows />
									Windows
								</div>
							</LocalizedLink>
                            <a id="mainnav-products-classicBeta" target="_blank" rel="noopener noreferrer" href="https://download-hr.utorrent.com/track/beta/endpoint/utorrent/os/windows" onClick={() => {this.props.togglePopup(null)}}>
                                <div className={`d-inline-block my-2 ${styles.img} pointer`} >
                                    <FaWindows />
                                    {t(`Windows Beta`)}
                                </div>
                            </a>
							<LocalizedLink id="mainnav-products-btclassic-mac" to="/downloads/mac" onClick={() => {this.props.togglePopup(null)}}> 
								<div className={`d-inline-block my-2 ${styles.img} pointer`} >
									<FaApple />
									Mac
								</div>
							</LocalizedLink>
							<LocalizedLink id="mainnav-products-btclassic-linux" to="/downloads/linux" onClick={() => {this.props.togglePopup(null)}}> 
								<div className={`d-inline-block my-2 ${styles.img} pointer`} >
									<FaLinux />
									Linux
								</div>
							</LocalizedLink>
						</div>

					</div>
					<div className="mt-2 mb-3">
						<LocalizedLink  className={styles.selection} id="mainnav-products-android" to="/mobile/" onClick={() => {this.props.togglePopup(null)}}> 
				  			<p className="mb-1">
				  				<span className="font-weight-bold bt-font text-primary">µTorrent </span> 
				  				{t("Android")}
				  			</p>
						</LocalizedLink>
					</div>
					<div className="mt-3 mb-4">
						<LocalizedLink  className={styles.selection} id="mainnav-products-btremote" to="/remote/" onClick={() => {this.props.togglePopup(null)}}> 
			  				<span className="font-weight-bold bt-font text-primary">µTorrent </span> 
			  				{t("Remote")}
						</LocalizedLink>
					</div>
				</div>
			</>,
			
		Language:
			<>
				<div className="row px-5 py-5 mx-3">
					<div className="col-6 py-3 px-0">
			  			<div>
					  		<Link onClick={(e) => {this.handleLanguageClick(e, "en")}} to={ this.props.unlocalizedPath } hrefLang="en"  id="mainnav-lang-en" className="dropdown-item language">
					          English
					        </Link>
			  			</div>
			  			<div>
					  		<Link onClick={(e) => {this.handleLanguageClick(e, "zh-cn")}} to={ unlocalizedPageCheck(this.props.unlocalizedPath) ? this.props.unlocalizedPath : '/intl/zh_cn'+ this.props.unlocalizedPath } hrefLang="zh_CN" id="mainnav-lang-zh-cn" className="dropdown-item language">
			                  中文（简体）
			                </Link>
			  			</div>
			  			<div>
					  		<Link onClick={(e) => {this.handleLanguageClick(e, "zh-tw")}} to={ unlocalizedPageCheck(this.props.unlocalizedPath) ? this.props.unlocalizedPath : '/intl/zh_tw'+ this.props.unlocalizedPath } hrefLang="zh_TW" id="mainnav-lang-zh-tw" className="dropdown-item language">
			                  中文（繁體）
			                </Link>
			  			</div>
			  			<div>
					  		<Link onClick={(e) => {this.handleLanguageClick(e, "de")}} to={ unlocalizedPageCheck(this.props.unlocalizedPath) ? this.props.unlocalizedPath : '/intl/de'+ this.props.unlocalizedPath } hrefLang="de" id="mainnav-lang-de" className="dropdown-item language">
			                  Deutsch
			                </Link>
			  			</div>
			  			<div >
					  		<Link onClick={(e) => {this.handleLanguageClick(e, "es")}} to={ unlocalizedPageCheck(this.props.unlocalizedPath) ? this.props.unlocalizedPath : '/intl/es'+ this.props.unlocalizedPath } hrefLang="es" id="mainnav-lang-es" className="dropdown-item language">
			                  Español
			                </Link>
			  			</div>
			  			<div >
					  		<Link onClick={(e) => {this.handleLanguageClick(e, "fr")}} to={ unlocalizedPageCheck(this.props.unlocalizedPath) ? this.props.unlocalizedPath : '/intl/fr'+ this.props.unlocalizedPath } hrefLang="fr" id="mainnav-lang-fr" className="dropdown-item language">
			                  Français
			                </Link>
			  			</div>
						<div>
					  		<Link onClick={(e) => {this.handleLanguageClick(e, "hi")}} to={ unlocalizedPageCheck(this.props.unlocalizedPath) ? this.props.unlocalizedPath : '/intl/hi'+ this.props.unlocalizedPath } hrefLang="hi" id="mainnav-lang-hi" className="dropdown-item language">
			                  हिन्दी
			                </Link>
			  			</div>
			  			<div>
					  		<Link onClick={(e) => {this.handleLanguageClick(e, "it")}} to={ unlocalizedPageCheck(this.props.unlocalizedPath) ? this.props.unlocalizedPath : '/intl/it'+ this.props.unlocalizedPath } hrefLang="it" id="mainnav-lang-it" className="dropdown-item language">
			                  Italiano
			                </Link>
			  			</div>
					</div>
					<div className="col-6 py-3">
			  			<div>
					  		<Link onClick={(e) => {this.handleLanguageClick(e, "ja")}} to={ unlocalizedPageCheck(this.props.unlocalizedPath) ? this.props.unlocalizedPath : '/intl/ja'+ this.props.unlocalizedPath } hrefLang="ja" id="mainnav-lang-ja" className="dropdown-item language">
			                  日本語
			                </Link>
			  			</div>
			  			<div>
					  		<Link onClick={(e) => {this.handleLanguageClick(e, "ko")}} to={ unlocalizedPageCheck(this.props.unlocalizedPath) ? this.props.unlocalizedPath : '/intl/ko'+ this.props.unlocalizedPath } hrefLang="ko" id="mainnav-lang-ko" className="dropdown-item language">
			                  한국어
			                </Link>
			  			</div>
			  			<div>
					  		<Link onClick={(e) => {this.handleLanguageClick(e, "nl")}} to={ unlocalizedPageCheck(this.props.unlocalizedPath) ? this.props.unlocalizedPath : '/intl/nl'+ this.props.unlocalizedPath } hrefLang="nl" id="mainnav-lang-nl" className="dropdown-item language">
			                  Nederlands
			                </Link>
			  			</div>
			  			<div>
					  		<Link onClick={(e) => {this.handleLanguageClick(e, "pl")}} to={ unlocalizedPageCheck(this.props.unlocalizedPath) ? this.props.unlocalizedPath : '/intl/pl'+ this.props.unlocalizedPath } hrefLang="pl" id="mainnav-lang-pl" className="dropdown-item language">
			                  Polski
			                </Link>
			  			</div>
			  			<div>
					  		<Link onClick={(e) => {this.handleLanguageClick(e, "pt-br")}} to={ unlocalizedPageCheck(this.props.unlocalizedPath) ? this.props.unlocalizedPath : '/intl/pt_br'+ this.props.unlocalizedPath } hrefLang="pt_BR" id="mainnav-lang-pt-br" className="dropdown-item language">
			                  Português (Brasil)
			                </Link>
			  			</div>
			  			<div>
					  		<Link onClick={(e) => {this.handleLanguageClick(e, "pt")}} to={ unlocalizedPageCheck(this.props.unlocalizedPath) ? this.props.unlocalizedPath : '/intl/pt'+ this.props.unlocalizedPath } hrefLang="pt" id="mainnav-lang-pt" className="dropdown-item language">
			                  Português
			                </Link>
			  			</div>
			  			<div>
					  		<Link onClick={(e) => {this.handleLanguageClick(e, "ru")}} to={ unlocalizedPageCheck(this.props.unlocalizedPath) ? this.props.unlocalizedPath : '/intl/ru'+ this.props.unlocalizedPath } hrefLang="ru" id="mainnav-lang-ru" className="dropdown-item language">
			                  Русский
			                </Link>
			  			</div>
			  			<div>
					  		<Link onClick={(e) => {this.handleLanguageClick(e, "tl")}} to={ unlocalizedPageCheck(this.props.unlocalizedPath) ? this.props.unlocalizedPath : '/intl/tl'+ this.props.unlocalizedPath } hrefLang="tl" id="mainnav-lang-tl" className="dropdown-item language">
			                  Tagalog
			                </Link>
			  			</div>
			  			<div>
					  		<Link onClick={(e) => {this.handleLanguageClick(e, "tr")}} to={ unlocalizedPageCheck(this.props.unlocalizedPath) ? this.props.unlocalizedPath : '/intl/tr'+ this.props.unlocalizedPath } hrefLang="tr" id="mainnav-lang-tr" className="dropdown-item language">
			                  Türkçe
			                </Link>
			  			</div>
					</div>
		  			
		        </div>
			</>

	}

	let width = (this.props.offset) ? this.props.offset + 62 : 575;
	return (
		<CSSTransition in={this.context.isPopupOpen} timeout={400} classNames="slide">
			<div className={styles.popup} style={{width: width}}>
				<div className={styles.popupInner}>
		  			<div className="container h-100 position-relative p-0 mb-5 pb-5 pt-4 pt-lg-0">

  						{q[`${this.context.selected}`]}

						<div className={styles.close} onClick={()=>{this.props.togglePopup(null)}}>
							<IoMdClose/>
						</div>
		  			</div>
				</div>
					
			</div>
		</CSSTransition>

	)
  }

}

NavPopup.contextType = NavContext;

export default NavPopup
